export const getColor = (status: 'pending' | 'success' | 'denied') => {
    switch (status) {
        case 'pending':
            return { title: "yuborildi", color: '#ffa940' }
        case 'denied':
            return { title: "bekor qilindi", color: '#ff4d4f' }
        default:
            return { title: "qabul qilindi", color: '#52c41a' }
    }
}